import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTuneinComponent } from './simple-icons-tunein.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTuneinComponent ],
    exports:      [ SimpleIconsTuneinComponent ],
    bootstrap:    []
})
export class SimpleIconsTuneinModule {}
